import { t } from "i18next";
import React from "react";
import { Trans } from "react-i18next";
import { useParams } from "react-router-dom";
import female1 from "../../../assets/images/blurred2/female/Age_1.png";
import female2 from "../../../assets/images/blurred2/female/Age_2.png";
import female3 from "../../../assets/images/blurred2/female/Age_3.png";
import female4 from "../../../assets/images/blurred2/female/Age_4.png";
import male1 from "../../../assets/images/blurred2/male/Age_1.png";
import male2 from "../../../assets/images/blurred2/male/Age_2.png";
import male3 from "../../../assets/images/blurred2/male/Age_3.png";
import male4 from "../../../assets/images/blurred2/male/Age_4.png";
import ImageButton from "../../../components/ImageButton";
import MobileViewLayout from "../../../layouts/MobileViewLayout";
import { addS3Url } from "../../../utils/modules";

const buttonText = [
  t("career_plan.age_18_24"),
  t("career_plan.age_25_34"),
  t("career_plan.age_35_44"),
  t("career_plan.age_45_plus"),
];

const imagesToPreload = {
  male: [
    "/staging/goal/male/1.png",
    "/staging/goal/male/2.png",
    "/staging/goal/male/3.png",
    "/staging/goal/male/4.png",
  ],
  female: [
    "/staging/goal/female/1.png",
    "/staging/goal/female/2.png",
    "/staging/goal/female/3.png",
    "/staging/goal/female/4.png",
  ],
};

const data = {
  male: [
    {
      image: addS3Url("/staging/male/Age_1.png"),
      placeHolderImage: male1,
    },
    {
      placeHolderImage: male2,
      image: addS3Url("/staging/male/Age_2.png"),
    },
    {
      placeHolderImage: male3,
      image: addS3Url("/staging/male/Age_3.png"),
    },
    {
      placeHolderImage: male4,
      image: addS3Url("/staging/male/Age_4.png"),
    },
  ],
  female: [
    {
      placeHolderImage: female1,
      image: addS3Url("/staging/female/Age_1.png"),
    },
    {
      placeHolderImage: female2,
      image: addS3Url("/staging/female/Age_2.png"),
    },
    {
      placeHolderImage: female3,
      image: addS3Url("/staging/female/Age_3.png"),
    },
    {
      placeHolderImage: female4,
      image: addS3Url("/staging/female/Age_4.png"),
    },
  ],
};

const AgeSelection = () => {
  const params = useParams();
  const gender = params.gender || "female";

  return (
    <MobileViewLayout>
      <div className="px-3">
        <h3 className="text-black fw-bold text-center m-0 fs30 age-selection-heading">
          <Trans i18nKey={"career_plan.title"} />
        </h3>
        <div className="d-flex flex-column justify-content-around align-items-center">
          <div
            className="d-flex justify-content-around align-items-center w-100"
            style={{ paddingBottom: "20px" }}
          >
            {data[gender].slice(0, 2).map((item, index) => (
              <ImageButton
                key={index}
                highlightButton={"image-button-highlight"}
                backgroundStyle={{
                  backgroundColor: "#F2F2F2",
                }}
                navigateTo={{
                  pathname: `/${params.gender}/goal`,
                  state: { age: item.buttonText, gender: params.gender },
                }}
                imageStyle={{ width: "100%", minHeight: "97px" }}
                buttonClasses={
                  "btn btn-primary py-1 rounded-0 rounded-bottom w-100 bgSecondary secondaryTextSize"
                }
                buttonText={buttonText[index]}
                imagesToPreload={imagesToPreload[gender]}
                {...item}
              />
            ))}
          </div>
          <div className="d-flex justify-content-around align-items-center w-100">
            {data[gender].slice(2, 4).map((item, index) => (
              <ImageButton
                key={index}
                highlightButton={"image-button-highlight"}
                backgroundStyle={{
                  backgroundColor: "#F2F2F2",
                }}
                navigateTo={{
                  pathname: `/${params.gender}/goal`,
                  state: { age: item.buttonText, gender: params.gender },
                }}
                imageStyle={{ width: "100%", minHeight: "97px" }}
                buttonClasses={
                  "btn btn-primary py-1 rounded-0 rounded-bottom w-100 bgSecondary secondaryTextSize"
                }
                buttonText={buttonText[2 + index]}
                imagesToPreload={imagesToPreload[gender]}
                {...item}
              />
            ))}
          </div>
        </div>
      </div>
    </MobileViewLayout>
  );
};

export default AgeSelection;
